export enum EuropeanCountryCode {
  AT = "AT",
  BE = "BE",
  BG = "BG",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DK = "DK",
  EE = "EE",
  ES = "ES",
  FI = "FI",
  FR = "FR",
  GR = "GR",
  HR = "HR",
  HU = "HU",
  IE = "IE",
  IS = "IS",
  IT = "IT",
  LI = "LI",
  LU = "LU",
  LV = "LV",
  MT = "MT",
  NL = "NL",
  NO = "NO",
  PL = "PL",
  PT = "PT",
  RO = "RO",
  SE = "SE",
  SI = "SI",
  SK = "SK",
  UK = "UK",
}

export enum NonEuropeanCountryCode {
  CH = "CH",
  AF = "AF",
}

export enum ZoneCode {
  FR = "fr",
  UE = "ue",
  Other = "autre",
  Empty = "",
}
